export default function DateIcon() {
  return (
    <svg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.8125 6.6875V14.1875C2.8125 15.0159 3.48407 15.6875 4.3125 15.6875H13.6875C14.5159 15.6875 15.1875 15.0159 15.1875 14.1875V6.6875M2.8125 6.6875V4.8125C2.8125 3.98407 3.48407 3.3125 4.3125 3.3125H5.8125M2.8125 6.6875H15.1875M15.1875 6.6875V4.8125C15.1875 3.98407 14.5159 3.3125 13.6875 3.3125H12.1875M5.8125 3.3125V4.47266M5.8125 3.3125H12.1875M12.1875 3.3125V4.47266'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
